"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var R = __importStar(require("ramda"));
var Questionnaire_1 = require("../Questionnaire");
var getOperatorEscalationUrl_1 = require("./getOperatorEscalationUrl");
var AnswerActions_1 = require("./AnswerActions");
var AnswerContent_1 = require("./AnswerContent");
var useStyles = core_1.makeStyles(function () { return ({
    avatar: {
        width: 30,
        height: 30
    },
    answer: {
        marginLeft: 15,
        textAlign: 'left',
        '& p': {
            marginBlockStart: 0,
            marginBlockEnd: 0
        },
        whiteSpace: 'pre-wrap',
        '& .md': {
            whiteSpace: 'normal'
        }
    },
    content: {
        display: 'flex'
    },
    button: {
        marginBottom: 1,
        textTransform: 'none'
    }
}); });
exports.Answer = function (_a) {
    var contents = _a.contents, onClick = _a.onClick, cardId = _a.cardId, answers = _a.answers, operatorEscalationKeyword = _a.operatorEscalationKeyword, karakuriWebRootUrl = _a.karakuriWebRootUrl, feedbackYes = _a.feedbackYes, feedbackNo = _a.feedbackNo, info = _a.info, session = _a.session, onFeedback = _a.onFeedback, skillApi = _a.skillApi;
    var classes = useStyles();
    var _b = react_1.default.useState([cardId]), selectionPath = _b[0], setSelectionPath = _b[1];
    var onActionSelected = function (e, id, external) {
        e.preventDefault();
        if (external) {
            onClick("/answer/" + id);
        }
        else {
            var actionList_1 = answers.filter(function (x) { return x.actions && x.actions.actions; }).map(function (x) { var _a; return ((_a = x.actions) === null || _a === void 0 ? void 0 : _a.actions.map(function (_) { return _.id; })) || []; });
            var paths = R.takeWhile(function (x) { return !actionList_1.some(function (_) { return _.includes(x) && _.includes(id); }); }, selectionPath);
            setSelectionPath(__spreadArrays(paths, [id]));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.CardContent, { className: clsx_1.default('faq-answer-content', classes.content) },
            react_1.default.createElement(core_1.Avatar, { "aria-label": "Answer", className: clsx_1.default('faq-answer-a', classes.avatar) }, info ? 'i' : 'A'),
            react_1.default.createElement(AnswerContent_1.AnswerContent, { className: classes.answer, contents: contents, skillApi: skillApi })),
        react_1.default.createElement(react_1.default.Fragment, null, answers && answers.length > 0
            ? answers.map(function (a) {
                if (!selectionPath.includes(a.id)) {
                    return null;
                }
                if (a.id === cardId) {
                    return (react_1.default.createElement(AnswerActions_1.AnswerActions, { key: a.id, className: classes.button, cardId: cardId, answers: answers, actions: a.actions, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }));
                }
                return (react_1.default.createElement(core_1.Fade, { key: a.id, in: selectionPath.includes(a.id) },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.Divider, { variant: "middle", light: true, style: { marginTop: 12, marginBottom: 12 } }),
                        react_1.default.createElement(AnswerContent_1.AnswerContent, { className: classes.answer, contents: a.contents, skillApi: skillApi }),
                        react_1.default.createElement(AnswerActions_1.AnswerActions, { className: classes.button, cardId: cardId, answers: answers, actions: a.actions, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }))));
            })
            : null),
        !info && (react_1.default.createElement(core_1.CardContent, null,
            react_1.default.createElement(Questionnaire_1.Questionnaire, { onFeedback: onFeedback, feedbackYes: feedbackYes, feedbackNo: feedbackNo, operatorEscalationUrl: getOperatorEscalationUrl_1.getOperatorEscalationUrl(cardId, answers || [], selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session) })))));
};
//# sourceMappingURL=index.js.map